import { Skeleton } from '@components/atoms/Skeleton/Skeleton';
import { Container } from '@components/ions/layouts';
import { DefaultLayout } from '@components/templates/DefaultLayout/DefaultLayout';

import { useResponsive } from '@utils/hooks/useResponsive';

import {
    ContentWrapper,
    DashboardPageWrapper,
    DashboardTitle,
    MobileContentWrapper,
    MobileTilesWrapper,
    SkeletonMobileWrapper,
    SkeletonsCompanyPolicies,
    SkeletonsContentWrapper,
} from './DashboardPage.styled';

export const SkeletonDashboardPage = () => {
    const isSm = useResponsive('sm');

    if (isSm)
        return (
            <DefaultLayout isSkeleton>
                <SkeletonMobileWrapper>
                    <MobileContentWrapper>
                        <Container>
                            <Skeleton />
                            <MobileTilesWrapper>
                                <Skeleton count={5} height={80} />
                            </MobileTilesWrapper>
                        </Container>
                    </MobileContentWrapper>
                </SkeletonMobileWrapper>
            </DefaultLayout>
        );

    return (
        <DefaultLayout isSkeleton>
            <DashboardPageWrapper>
                <ContentWrapper>
                    <Container>
                        <DashboardTitle>
                            <Skeleton variant={'inverted'} />
                        </DashboardTitle>
                        <SkeletonsContentWrapper>
                            <Skeleton variant={'inverted'} />
                            <Skeleton
                                count={3}
                                height={140}
                                variant={'inverted'}
                            />
                        </SkeletonsContentWrapper>
                    </Container>
                </ContentWrapper>
                <Container>
                    <SkeletonsCompanyPolicies>
                        <Skeleton height={200} width={500} />
                        <Skeleton count={4} height={110} width={720} />
                    </SkeletonsCompanyPolicies>
                </Container>
            </DashboardPageWrapper>
        </DefaultLayout>
    );
};
